(() => {
    'use strict';
    angular.module('deals').directive('dealTypeCards', dealTypeCards);

    function dealTypeCards(
        holidayDeals
    ) {
        const imgUrl = `${TRPCONFIG.DestinationImagesClientDomain}api2/destination/images/getfromobject`;

        function link(scope) {
            scope.holidayDealsEnabled = TRPCONFIG.Domain.HolidayDealsEnabled;
            scope.cruiseEnabled = TRPCONFIG.Domain.HolidayDealsCruisesEnabled;

            if (scope.holidayDealsEnabled && !scope.cruiseEnabled) {
                bestDestination().then(dest => scope.dest = dest);
            }
        }

        function bestDestination() {
            const depAir = TRPCONFIG.Domain.HolidayDealsDefaultAirports;

            return holidayDeals.getAggregates(false, { depAir })
                .then(response => _.get(response, 'Aggregates.HotelsByChildDestination'))
                .then(destMap => _.chain(destMap)
                    .mapValues((dest, key) => _.merge(dest, { id: key }))
                    .values()
                    .sortBy('Position')
                    .first()
                    .value()
                )
                .then(dest => {
                    const [type, id] = _.chain(dest).get('id').split('|').value();
                    const href = `holidaydeals?depAir=${depAir}&ChildDestinations=${type}|${id}`;
                    return {
                        title: _.get(dest, 'Title'),
                        image: `${imgUrl}?${jQuery.param({
                            height: 316,
                            useDealsImages: true,
                            type,
                            id
                        })}`,
                        href: window.encodeURI(href),
                        minPrice: _.get(dest, 'MinPrice')
                    };
                });
        }

        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl: 'partials/home/directivetemplate?type=DealTypeCards',
            link
        };
    }
})();
